module.exports = __webpack_public_path__ + "img/mouse.97990565.svg";